interface ChipProps {
  label: string;
  active: boolean;
  onClick: () => void;
  count?: number;
}

export default function Chip({ label, active, onClick, count }: ChipProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
        active
          ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
          : 'bg-background-100 text-foreground-700 hover:bg-background-200'
      }`}
    >
      {label}
      {typeof count === 'number' && (
        <span className={`ml-1.5 text-xs ${active ? 'text-background-200' : 'text-foreground-500'}`}>
          {count}
        </span>
      )}
    </button>
  );
}